export const initialHomeLogsState = {
    messageLogsByHomeId: {},
    httpLogsByHomeId: {},
};
